import axios from 'axios';

import store from '@/store';
import { AUTH_REFRESH, AUTH_SUCCESS, AUTH_ERROR } from '../store/actions/auth';

const apiCall = async props => {
	if (isTokenExpired() && store.getters.authStatus != AUTH_REFRESH) {
		await refreshToken();
	}

	apiClient.defaults.headers.common[
		'Authorization'
	] = `Bearer ${store.state.auth.token}`;

	apiClient.defaults.headers.post['Content-Type'] =
		'application/x-www-form-urlencoded';

	return apiClient.request({
		...props,
	});
};

const apiClient = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	headers: {
		'Content-Type': 'application/json',
	},
	withCredentials: true,
});

const isTokenExpired = () => {
	const expiry = parseInt(localStorage.getItem('user-token-expiry'));
	const created_at = parseInt(localStorage.getItem('user-token-created-at'));
	const now = parseInt(new Date().getTime() / 1000);
	return now >= expiry + created_at;
};

const refreshToken = async () => {
	const data = {
		grant_type: 'refresh_token',
		client_id: process.env.VUE_APP_CLIENT_ID,
		client_secret: process.env.VUE_APP_CLIENT_SECRET,
		refresh_token: localStorage.getItem('user-token-refresh'),
	};
	await apiClient
		.request({ url: '/oauth/token', data, method: 'POST' })
		.then(resp => {
			store.commit(AUTH_SUCCESS, resp);
		})
		.catch(err => {
			store.commit(AUTH_ERROR, err);
		});
};

export default apiCall;
